import * as tslib_1 from "tslib";
import { combineLatest, map, takeUntil } from 'rxjs/operators';
import { OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import * as cart from '../../../cart/actions/cart';
import * as products from '../../actions/product';
import * as facet from '../../actions/facet';
import * as catalog from '../../actions/catalog';
import * as preferences from '../../../base/actions/preferences.actions';
import * as fromCatalog from '../../reducers';
import * as fromCart from '../../../cart/reducers';
import * as fromBase from '../../../base/reducers';
import * as fromAuth from '../../../auth/reducers';
import { PageRoutingService } from '../../../core/services/page-routing.service';
import { FacetRoutingService } from '../../../facets/services/facet-routing-service';
import { ContainerBase } from '../../../core/base/container-base';
import chaining from '../../../core/helpers/chaining';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DetailsContainer } from '../details-container/details-container';
var CatalogContainer = /** @class */ (function (_super) {
    tslib_1.__extends(CatalogContainer, _super);
    function CatalogContainer(modalSvc, router, store, facetRouting, translate, pageRouting, route) {
        var _this = _super.call(this) || this;
        _this.modalSvc = modalSvc;
        _this.router = router;
        _this.store = store;
        _this.facetRouting = facetRouting;
        _this.translate = translate;
        _this.pageRouting = pageRouting;
        _this.route = route;
        _this.loading = true;
        _this.allowOutOfStockOrdering = false;
        // Observables
        _this.productState$ = store
            .pipe(select(fromCatalog.getProductState), takeUntil(_this.destroyed$));
        _this.facetState$ = store
            .pipe(select(fromCatalog.getFacetState), takeUntil(_this.destroyed$));
        _this.cartProducts$ = store
            .pipe(select(fromCart.getCartProducts), takeUntil(_this.destroyed$));
        _this.favoritesProducts$ = store
            .pipe(select(fromCatalog.getFavorites), takeUntil(_this.destroyed$));
        _this.viewType$ = store
            .pipe(select(fromBase.getViewType), takeUntil(_this.destroyed$));
        _this.viewTypeAdjustable$ = store
            .pipe(select(fromBase.getViewTypeAdjustable), takeUntil(_this.destroyed$));
        _this.sideMenu$ = store
            .pipe(select(fromBase.getSideMenuList), takeUntil(_this.destroyed$));
        _this.orderLines$ = store
            .pipe(select(fromCart.getCurrentOrderLines), takeUntil(_this.destroyed$));
        _this.combinedFacets$ = store
            .pipe(select(fromCatalog.getCombinedFacets), takeUntil(_this.destroyed$));
        _this.currentPage$ = store
            .pipe(select(fromBase.getCurrentPage), takeUntil(_this.destroyed$));
        _this.catalogSortOrders$ = store
            .pipe(select(fromBase.getCatalogSortOrders), takeUntil(_this.destroyed$));
        _this.sortOrder$ = store
            .pipe(select(fromCatalog.getProductSortOrder), takeUntil(_this.destroyed$));
        _this.detailsPageSettings$ = _this.store.pipe(select(fromBase.getItemDetailsPageSettings), takeUntil(_this.destroyed$));
        _this.catalogItemPageSettings$ = _this.store.pipe(select(fromBase.getCatalogItemPageSettings), takeUntil(_this.destroyed$));
        _this.catalogPageSettings$ = _this.store.pipe(select(fromBase.getCatalogPageSettings), takeUntil(_this.destroyed$));
        _this.searchPageSettings$ = _this.store.pipe(select(fromBase.getSearchPageSettings), takeUntil(_this.destroyed$));
        _this.store.pipe(select(fromAuth.getUserPermissions), takeUntil(_this.destroyed$)).subscribe(function (permissions) {
            // First check if user is allowed to see stock info. If not, allowOutOfStockOrdering should be true since no stock info is available
            if (permissions.indexOf('VIEW_STOCK_INFO') === -1) {
                _this.allowOutOfStockOrdering = true;
            }
            else {
                // User is allowed to see stock. Check for ALLOW_OUT_OF_STOCK_ORDERING permission.
                if (permissions.indexOf('ALLOW_OUT_OF_STOCK_ORDERING') > -1) {
                    _this.allowOutOfStockOrdering = true;
                }
            }
        });
        _this.quantityPicker$ = _this.store.pipe(select(fromBase.getQuantityPicker), takeUntil(_this.destroyed$));
        _this.sideMenuIds$ = _this.store.pipe(select(fromBase.getSideMenuIds), takeUntil(_this.destroyed$));
        _this.menuItems$ = _this.store.pipe(select(fromBase.getMenuEntities), takeUntil(_this.destroyed$));
        _this.activeChain$ = _this.store.pipe(select(fromBase.getActiveMenuChain), takeUntil(_this.destroyed$));
        // get show breadcrumbs
        _this.store.pipe(select(fromBase.getTenantSettings), takeUntil(_this.destroyed$)).subscribe(function (settings) {
            _this.showCrumbs = settings.show_breadcrumbs;
        });
        // get crumbs
        _this.crumbs$ = _this.pageRouting.breadCrumbs$;
        // Dispatch init
        _this.store.dispatch(new catalog.Init());
        // Subscriptions
        _this.facetRoutingSub = facetRouting
            .pipe(map(function (facets) { return new facet.Apply(facets); })).subscribe(store);
        _this.facetState$.pipe(combineLatest(_this.productState$, function (facets, products) { return facets.loading || products.loading; })).subscribe(function (loading) { return _this.loading = loading; });
        _this.loaded$ = _this.store.pipe(select(fromCatalog.getProductsLoaded), takeUntil(_this.destroyed$));
        _this.orderLines$
            .subscribe(function (orderLines) { return _this.orderLines = orderLines; });
        return _this;
    }
    CatalogContainer.prototype.ngOnDestroy = function () {
        // Reset facet filter state & products state
        this.store.dispatch(new facet.FilterReset());
        this.store.dispatch(new products.ClearState());
        _super.prototype.ngOnDestroy.call(this);
        this.facetRoutingSub.unsubscribe();
    };
    CatalogContainer.prototype.expandProducts = function () {
        this.store.dispatch(new products.Expand());
    };
    CatalogContainer.prototype.facetToggled = function (event) {
        this.facetRouting.toggleFacet(event);
    };
    CatalogContainer.prototype.groupToggled = function (event) {
        this.store.dispatch(new facet.ShowMore(event));
    };
    CatalogContainer.prototype.onlyInStockToggled = function () {
        this.store.dispatch(new products.ToggleInStock());
    };
    CatalogContainer.prototype.openDetails = function (product) {
        this.store.dispatch(new products.Select(product));
        this.modalSvc.open(DetailsContainer, { centered: true, size: 'lg' });
    };
    CatalogContainer.prototype.toggleFavorite = function (event) {
        event.isFavorite
            ? this.store.dispatch(new products.RemoveFavorite(event.product))
            : this.store.dispatch(new products.AddFavorite(event.product));
    };
    CatalogContainer.prototype.addCart = function (event) {
        var orderLineId = chaining(this.orderLines.find(function (line) { return chaining(line, 'product._id') === chaining(event, 'product'); }), '_id');
        if (chaining(event, 'quantity') > 0) {
            this.store.dispatch(new cart.Add({
                product: event.product,
                quantity: event.quantity
            }));
        }
        else if (event.quantity <= 0 && orderLineId)
            this.store.dispatch(new cart.Remove({
                lineId: orderLineId
            }));
    };
    CatalogContainer.prototype.typeSwitch = function (type) {
        this.store.dispatch(new preferences.SetViewType(type));
    };
    CatalogContainer.prototype.onFilterToggled = function (event) {
        this.store.dispatch(new products.SetProductFilter(event));
    };
    CatalogContainer.prototype.onSortOrderToggle = function (event) {
        this.store.dispatch(new products.SetProductSortOrder(event));
    };
    return CatalogContainer;
}(ContainerBase));
export { CatalogContainer };
